// Timezone capture — the browser knows the user's IANA zone; the backend has
// no other way to learn it (the TG surface has no signal at all, there it's
// the /timezone command). Sent with every auth payload and stored per user,
// so the LLM time context ("Сейчас" header, "текущая дата и время") renders
// in the user's wall clock instead of MSK (boards card cxdwx45zr: the model
// told a UTC-4 user «почти три часа ночи» at her 8 PM).
export function getUserTimeZone(): string | null {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null
  } catch {
    return null
  }
}
